export enum EnumStatusManifesto {
    ResumoNFe = 5,
    ResumoEvento = 6,
    EventosDeConfirmacaoDeOperacao = 210200,
    EventosDeCienciaDaOperacao = 210210,
    EventosDeDesconhecimentoDaOperacao = 210220,
    EventosDeOperacaoNaoRealizada = 210240,
}